import { h } from '@stencil/core';
import cn from 'classnames';
import { NAVIGATION_STATE_PARAM_NAME, FILTER_STATE_CHANGED_EVENT_NAME, pesCatalogPageTypes, setPaginationParams } from '@pes-ui/utils';
import { isBrowser, isMobile } from '../../globals/utils';
import { filterReset, getBaseUrl, getCategoryOrSubCatFilterUrl, getCategoryRangesFilterUrl, getFilterProductsUrl, getPbsFilterProductsUrl, getPbsRangesfiltersUrl, getQueryParam, setNavigationFilterPath, getPaginationParams, } from '../../globals/utils/helpers';
import { listingTypes, pageParam, MAX_RANGES_BEFORE_SDL_PROMO_BANNER, MAX_VISIBLE_CARDS_WHILE_COLLAPSED, DEFAULT_CATEGORY_PRODUCT_CTAS, } from '../category-subcategory-listing/constants';
import { fetchSprykerFilters, trackFilterAnalytics, } from '../../globals/utils/normalizeFiltersData';
import { getData } from '../../globals/http';
export class PesSprykerCategorySubcategoryListing {
  constructor() {
    this.renderHMC = () => {
      if (this.hideHMCBanner || !this.hmcBanner) {
        return;
      }
      return (h("pes-hmc-banner", { class: {
          'category-subcategory-listing__hmc-banner': true,
          'category-subcategory-listing__hmc-banner--top': this.showHMConTop,
        }, categoryName: this.hmcBanner.categoryName, labels: this.hmcBanner.labels, sourceId: this.hmcBanner.pimId, parentCategoryId: this.hmcBanner.parentCategoryId, categoryProductConfiguratorUrl: this.hmcBanner.categoryProductConfiguratorUrl, hasQuestionnaire: this.hmcBanner.hasQuestionnaire, questionnaireUrl: this.hmcBanner.questionnaireUrl, rangeTooltipUrl: this.hmcBanner.rangeTooltipUrl, selectorConfigUrl: this.hmcBanner.selectorConfigUrl, isExternalProductConfiguratorUrl: this.hmcBanner.isExternalProductConfiguratorUrl, variant: "square", hmcHost: this.hmcBanner.host, token: this.hmcBanner.token, channel: this.hmcBanner.channel, pageSource: this.hmcBanner.pageSource }));
    };
    this.localeCode = undefined;
    this.host = '';
    this.subcategorySection = undefined;
    this.productsSection = undefined;
    this.filtersSection = undefined;
    this.hmcBanner = undefined;
    this.hideHMCBanner = false;
    this.navigationState = '';
    this.filtersUrl = undefined;
    this.productsUrl = undefined;
    this.rangesUrl = undefined;
    this.numberOfProducts = undefined;
    this.showDocuments = undefined;
    this.showBuyOnline = true;
    this.enableCommerceConnector = true;
    this.avoidAccents = false;
    this.hiddenSubcategoriesInfo = undefined;
    this.pageParam = undefined;
    this.isBrowser = isBrowser();
    this.showCompare = true;
    this.searchParams = {};
    this.isSubcategoryPage = false;
    this.isPBS = false;
    this.storageName = undefined;
    this.currentPageStorageKey = undefined;
    this.productCtas = DEFAULT_CATEGORY_PRODUCT_CTAS;
    this.filtersNormalized = undefined;
    this.filtrationSmartData = undefined;
    this.pills = undefined;
    this.isMobileView = isMobile();
    this.isFilterInMobileViewVisible = false;
    this.isMobileCategorySelected = Boolean(this.navigationState);
    this.filtersCategories = undefined;
    this.productsCount = undefined;
    this.selectedSectionsCount = undefined;
    this.isProductsLoading = false;
    this.sprykerParsedProducts = null;
    this.selectedPage = undefined;
    this.initialNavState = '';
    this.currentNavState = this.navigationState;
    this.initialFilterUrl = undefined;
    this.subCategoryProductListingParams = undefined;
    this.selectedFilterUrl = undefined;
    this.isLoadingFilters = false;
    this.PBSoffset = 0;
    this.breadcrumbs = [];
    this.analyticsPageData = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  async componentWillLoad() {
    const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
    this.selectedPage = Math.floor(offset / productsPerPage) + 1;
    this.initialFilterUrl = this.initialBaseFiltersUrl;
    this.subCategoryProductListingParams = {
      pageParam: this.pageParam,
      subCategoryId: this.navigationState,
    };
    const filter = this.getSearchParam() || '';
    this.selectedFilterUrl = getCategoryOrSubCatFilterUrl(this.filtersUrl, this.localeCode, this.subCategoryProductListingParams, filter);
    if (this.isBrowser) {
      await this.loadData(this.selectedFilterUrl, true);
    }
  }
  windowSizeDidChange() {
    this.isMobileView = isMobile();
    if (!this.isMobileView && this.isFilterInMobileViewVisible) {
      this.isFilterInMobileViewVisible = false;
    }
  }
  choosePage(event) {
    this.selectedPage = event.detail;
    const { productsPerPage } = this.getPaginationParamsWithDefaults;
    if (!this.isPBS) {
      setPaginationParams(productsPerPage * (this.selectedPage - 1), productsPerPage, true);
    }
    this.PBSoffset = productsPerPage * (this.selectedPage - 1);
    this.loadProducts(this.selectedFilterUrl);
  }
  onToggleFilterMobileViewVisibility() {
    this.isFilterInMobileViewVisible = !this.isFilterInMobileViewVisible;
  }
  onSelectCategoryHandler(event) {
    console.log('event.detail', event.detail);
    this.loadData(event.detail);
    this.isMobileCategorySelected = true;
  }
  mobileCategoryReset() {
    this.isMobileCategorySelected = false;
  }
  onFilterStateChanged(event) {
    const { lastChangedFilterId: filterId } = event.detail;
    if (filterId) {
      const { checkedURL, unCheckedURL } = this.filtersNormalized.entities.filter[filterId];
      const changedFilterUrl = unCheckedURL !== '' ? unCheckedURL : checkedURL;
      this.changeFilter(changedFilterUrl, filterReset(changedFilterUrl, this.initialFilterUrl), '');
    }
  }
  removePillHandler(event) {
    const unCheckedURL = event.detail;
    this.changeFilter(unCheckedURL, filterReset(unCheckedURL, this.initialFilterUrl));
  }
  resetAllFiltersHandler() {
    this.changeFilter(this.initialFilterUrl, true);
  }
  handlePopState() {
    if (!this.isPBS) {
      const { offset, productsPerPage } = this.getPaginationParamsWithDefaults;
      this.selectedPage = Math.floor(offset / productsPerPage) + 1;
      this.loadData(getCategoryOrSubCatFilterUrl(this.filtersUrl, this.localeCode, this.subCategoryProductListingParams));
    }
  }
  trackAnalyticsEventListener(e) {
    const { event } = e.detail;
    if (!event)
      return;
    if (event === FILTER_STATE_CHANGED_EVENT_NAME)
      trackFilterAnalytics(e, this.filtersNormalized);
  }
  changeFilter(changedFilterUrl, isReset, seoUrl) {
    if (!this.isPBS) {
      setNavigationFilterPath(changedFilterUrl, this.navigationState, isReset, seoUrl);
    }
    this.PBSoffset = 0;
    this.selectedPage = 1;
    this.selectedFilterUrl = changedFilterUrl;
    this.loadData(changedFilterUrl);
  }
  buildSearchParam(param) {
    return param in this.searchParams ? this.searchParams[param] : '';
  }
  getSearchParam(param = 'filter') {
    return this.isPBS ? this.buildSearchParam(param) : getQueryParam(param);
  }
  get hasProducts() {
    var _a;
    return !((_a = this.subcategorySection) === null || _a === void 0 ? void 0 : _a.hideProducts);
  }
  get showHMConTop() {
    return !this.hasProducts && !this.isMobileView;
  }
  get initialBaseFiltersUrl() {
    const categoriesFiltersBaseUrl = getBaseUrl(this.filtersUrl, this.localeCode);
    const subCategoriesBaseUrl = `${getBaseUrl(this.filtersUrl, this.localeCode)}&subcategory-id=${this.navigationState}&pageParam=${pageParam.SUBCATEGORY_LISTING}`;
    return this.pageParam === listingTypes.SUBCATEGORY_LISTING
      ? subCategoriesBaseUrl
      : categoriesFiltersBaseUrl;
  }
  get hasSubcategory() {
    var _a;
    return !!((_a = this.subcategorySection) === null || _a === void 0 ? void 0 : _a.subcategory);
  }
  get getPaginationParamsWithDefaults() {
    return getPaginationParams({
      offset: 0,
      productsPerPage: Number(this.numberOfProducts),
    });
  }
  async loadData(filterUrl, isInitialLoad = false) {
    const searchParams = new URLSearchParams(window.location.search);
    this.loadFilters(`${this.host}${filterUrl}`);
    if (!isInitialLoad || searchParams.has(NAVIGATION_STATE_PARAM_NAME)) {
      await this.loadRanges(filterUrl);
    }
    if (this.hasProducts) {
      this.loadProducts(filterUrl);
    }
  }
  async loadFilters(filterUrl) {
    try {
      this.isLoadingFilters = true;
      const { filtersNormalized, filtrationSmartData, pills, filtersCategories, selectedSectionsCount, } = await fetchSprykerFilters(filterUrl);
      this.filtersNormalized = filtersNormalized;
      this.filtrationSmartData = filtrationSmartData;
      this.pills = pills !== null && pills !== void 0 ? pills : [];
      this.filtersCategories = filtersCategories;
      this.selectedSectionsCount = selectedSectionsCount > 0 ? selectedSectionsCount : 0;
    }
    catch (error) {
      console.error(error);
    }
    finally {
      this.isLoadingFilters = false;
    }
  }
  loadProducts(filtersUrl) {
    this.isProductsLoading = true;
    const PPWProductFiltersUrl = getFilterProductsUrl(this.productsUrl, this.numberOfProducts, this.localeCode, '', this.subCategoryProductListingParams);
    const PBSProductFiltersUrl = getPbsFilterProductsUrl({
      host: this.host,
      ProductsPath: this.productsUrl,
      CheckedFiltersUrl: filtersUrl,
      pbsOffset: this.PBSoffset,
      Nrpp: this.numberOfProducts,
    });
    const url = !this.isPBS ? PPWProductFiltersUrl : PBSProductFiltersUrl;
    getData(false, url)
      .then((response) => {
      const { totalNumRecs } = response;
      this.sprykerParsedProducts = response;
      this.productsCount = totalNumRecs;
    })
      .finally(() => {
      this.isProductsLoading = false;
    });
  }
  async loadRanges(filtersUrl) {
    const PPWRangesFiltersUrl = getCategoryRangesFilterUrl(this.rangesUrl, this.localeCode, this.subCategoryProductListingParams);
    const PBSRangesFiltersUrl = getPbsRangesfiltersUrl({
      host: this.host,
      rangesPath: this.rangesUrl,
      CheckedFiltersUrl: filtersUrl,
    });
    const url = !this.isPBS ? PPWRangesFiltersUrl : PBSRangesFiltersUrl;
    const response = await getData(false, url);
    if (this.pageParam === listingTypes.SUBCATEGORY_LISTING && response.subcategory) {
      response.subcategory.name = null;
      response.subcategory.description = null;
    }
    this.subcategorySection = response;
  }
  renderFilters() {
    if (!this.filtrationSmartData) {
      return;
    }
    return (h("pes-responsive-filters", { filtrationSmartData: this.filtrationSmartData, resetButtonLabel: this.filtersSection.labels.facetButtonResetAll, viewMoreFacetsLabel: this.filtersSection.labels.facetButtonViewMoreFilters, viewLessFacetsLabel: this.filtersSection.labels.facetButtonViewLessFilters, headerLabelDesktop: this.filtersSection.labels.commonFiltersFilterBy, headerLabelMobile: this.filtersSection.labels.rangeProductsFilters, viewProductsLabel: this.filtersSection.labels.viewProducts, viewMoreRefinementsLabel: this.filtersSection.labels.viewMore, viewLessRefinementsLabel: this.filtersSection.labels.viewLess, noProductsFoundLabel: this.filtersSection.labels.noProductsFound, isMobileViewVisible: this.isFilterInMobileViewVisible, isMobileCategorySelected: this.isMobileCategorySelected, selectedSectionsCount: this.selectedSectionsCount, productsCount: this.productsCount, categories: this.filtersCategories, onShowMobileFilter: () => (this.isFilterInMobileViewVisible = true) }));
  }
  renderSubcategoryBlock() {
    const { labels, subcategory, sdlPromoBlocks, productTypeFilterSelected, } = this.subcategorySection;
    if (sdlPromoBlocks) {
      return h("pes-subcategory-promo-blocks", { subcategoryPromoBlocksData: sdlPromoBlocks });
    }
    if (this.hasSubcategory) {
      return (h("pes-subcategory-list", null, h("pes-subcategory-block", { slot: "pes-subcategory-block", subCategory: subcategory, rangePartofLabel: labels.rangePartofLabel, viewOnLabel: labels.viewOnLabel, productRelationsViewProdLabel: labels.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: labels.rangeProductsViewDetailsLabel, readMoreLabel: labels.readMoreLabel, readLessLabel: labels.readLessLabel, rangesSectionTitleLabel: labels.rangesSectionTitle, viewMoreLabel: labels.viewMore, viewLessLabel: labels.viewLess, rangeBlockCollapsible: this.hasProducts, showDescriptionBlock: !this.isSubcategoryPage && productTypeFilterSelected, avoidAccents: this.avoidAccents, navState: this.currentNavState, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName, shouldHaveSubcategory: this.isSubcategoryPage })));
    }
    return null;
  }
  getHiddenSubcategories() {
    var _a;
    const { subcategory, sdlPromoBlocks } = this.subcategorySection;
    if (!((_a = this.hiddenSubcategoriesInfo) === null || _a === void 0 ? void 0 : _a.length)) {
      return [];
    }
    if (sdlPromoBlocks || !subcategory) {
      return this.hiddenSubcategoriesInfo;
    }
    const { sdlCategoryPromo } = subcategory;
    const visibleRanges = subcategory.ranges.slice(0, sdlCategoryPromo ? MAX_RANGES_BEFORE_SDL_PROMO_BANNER : MAX_VISIBLE_CARDS_WHILE_COLLAPSED);
    const visibleRangesIDs = visibleRanges.map((range) => range.id);
    return this.hiddenSubcategoriesInfo.reduce((accCategories, subCategories) => {
      const category = Object.assign(Object.assign({}, subCategories), { ranges: subCategories.ranges.filter((range) => {
          return !visibleRangesIDs.includes(range.id);
        }) });
      if (category.ranges.length > 0) {
        accCategories.push(category);
      }
      return accCategories;
    }, []);
  }
  renderHiddenSubcategories() {
    const subCategories = this.getHiddenSubcategories();
    if (!subCategories.length) {
      return null;
    }
    const { labels } = this.subcategorySection;
    return (h("pes-subcategory-list", { class: "hidden-subcategories" }, subCategories.map((subCategory) => (h("pes-subcategory-block", { slot: "pes-subcategory-block", subCategory: subCategory, rangePartofLabel: labels.rangePartofLabel, viewOnLabel: labels.viewOnLabel, productRelationsViewProdLabel: labels.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: labels.rangeProductsViewDetailsLabel, readMoreLabel: labels.readMoreLabel, readLessLabel: labels.readLessLabel, rangesSectionTitleLabel: labels.rangesSectionTitle, viewMoreLabel: labels.viewMore, viewLessLabel: labels.viewLess, avoidAccents: this.avoidAccents, navState: this.currentNavState, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName, shouldHaveSubcategory: this.isSubcategoryPage, rangeBlockCollapsible: this.hasProducts })))));
  }
  renderProducts() {
    var _a;
    if (!this.hasProducts) {
      return null;
    }
    const { productsPerPage } = this.getPaginationParamsWithDefaults;
    const areProductsHidden = this.isMobileView
      && (this.isFilterInMobileViewVisible
        || (!this.isMobileCategorySelected && ((_a = this.filtersCategories) === null || _a === void 0 ? void 0 : _a.length) > 0));
    return (h("pes-category-subcategory-products-list", { class: cn('category-subcategory-listing__products', {
        'category-subcategory-listing__products--hidden': areProductsHidden,
      }), hostWithLocale: this.isPBS ? this.host : this.localeCode, storageName: this.storageName, navigationState: this.navigationState, isProductsLoading: this.isProductsLoading, parsedProducts: this.sprykerParsedProducts, selectedPage: this.selectedPage, productsPerPage: productsPerPage, pills: this.pills, isMobileView: this.isMobileView, isMobileCategorySelected: this.isMobileCategorySelected, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, enableCommerceConnector: this.enableCommerceConnector, numberProductsOfAllProductsLabel: this.productsSection.labels.numberProductsOfAllProducts, appProductsLabel: this.productsSection.labels.appProducts, loadMoreLabel: this.productsSection.labels.loadMore, loadPreviousLabel: this.productsSection.labels.loadPrevious, previousLabel: this.productsSection.labels.previous, labelValue: this.productsSection.labels.pageLabel, nextLabel: this.productsSection.labels.next, productsSectionTitleLabel: this.productsSection.labels.title, noResultsClearLinkLabel: this.productsSection.labels.noResultsClearLink, noResultsHeaderLabel: this.productsSection.labels.noResultsHeader, noResultsMessageLabel: this.productsSection.labels.noResultsMessage, enableAppRouting: this.isPBS, localeCode: this.localeCode, isPBS: this.isPBS, productCtas: this.productCtas, showCompare: this.showCompare, analyticsPageData: this.analyticsPageData, currentPageStorageKey: this.currentPageStorageKey, parentPage: this.isSubcategoryPage ? pesCatalogPageTypes.SUBCATEGORY : pesCatalogPageTypes.CATEGORY }));
  }
  render() {
    return (h("main", { class: "category-subcategory-listing" }, h("div", { class: {
        'category-subcategory-listing__overlay': true,
        'category-subcategory-listing__overlay--visible': this.isLoadingFilters,
      } }), h("aside", { class: "category-subcategory-listing__filters" }, this.renderFilters(), !this.showHMConTop && this.renderHMC()), h("section", { class: {
        'category-subcategory-listing__content': true,
        'category-subcategory-listing__content--with-subcategory': this.hasSubcategory,
      } }, this.showHMConTop && this.renderHMC(), this.renderSubcategoryBlock(), this.renderHiddenSubcategories(), this.renderProducts())));
  }
  static get is() { return "pes-spryker-category-subcategory-listing"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-spryker-category-subcategory-listing.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-spryker-category-subcategory-listing.css"]
    };
  }
  static get properties() {
    return {
      "localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "host",
        "reflect": false,
        "defaultValue": "''"
      },
      "subcategorySection": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TSubCategorySection",
          "resolved": "{ hideProducts: boolean; productTypeFilterSelected?: boolean; sdlPromoBlocks?: SubcategoryPromoBlocks; subcategory?: TSubCategory; labels?: { rangesSectionTitle: string; viewMore: string; viewLess: string; rangePartofLabel: string; rangeProductsViewDetailsLabel: string; productRelationsViewProdLabel: string; readMoreLabel: string; readLessLabel: string; viewOnLabel: string; }; }",
          "references": {
            "TSubCategorySection": {
              "location": "import",
              "path": "../category-subcategory-listing/types"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productsSection": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsSection",
          "resolved": "{ labels: { appProducts: string; numberProductsOfAllProducts: string; title: string; noResultsMessage: string; loadPrevious: string; previous: string; noResultsHeader: string; noResultsClearLink: string; next: string; loadMore: string; pageLabel: string; }; }",
          "references": {
            "ProductsSection": {
              "location": "import",
              "path": "../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "filtersSection": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "FiltersSection",
          "resolved": "{ labels: { viewProducts: string; commonFiltersFilterBy: string; rangeProductsFilters: string; viewMore: string; facetButtonViewMoreFilters: string; facetButtonResetAll: string; facetButtonViewLessFilters: string; viewLess: string; noProductsFound: string; }; }",
          "references": {
            "FiltersSection": {
              "location": "import",
              "path": "../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "hmcBanner": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "THMCBanner",
          "resolved": "{ sourceId?: string; parentCategoryId?: string; categoryName?: string; labels?: THMCBannerLabels; hasQuestionnaire?: boolean; categoryProductConfiguratorUrl?: string; questionnaireUrl?: string; rangeTooltipUrl?: string; selectorConfigUrl?: string; isExternalProductConfiguratorUrl?: boolean; pimId?: string; host?: string; token?: string; channel?: string; pageSource?: string; }",
          "references": {
            "THMCBanner": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "hideHMCBanner": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "hide-h-m-c-banner",
        "reflect": false,
        "defaultValue": "false"
      },
      "navigationState": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "navigation-state",
        "reflect": false,
        "defaultValue": "''"
      },
      "filtersUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "filters-url",
        "reflect": false
      },
      "productsUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "products-url",
        "reflect": false
      },
      "rangesUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "ranges-url",
        "reflect": false
      },
      "numberOfProducts": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "number-of-products",
        "reflect": false
      },
      "showDocuments": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-documents",
        "reflect": false
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-buy-online",
        "reflect": false,
        "defaultValue": "true"
      },
      "enableCommerceConnector": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-commerce-connector",
        "reflect": false,
        "defaultValue": "true"
      },
      "avoidAccents": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "avoid-accents",
        "reflect": false,
        "defaultValue": "false"
      },
      "hiddenSubcategoriesInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSubCategory[]",
          "resolved": "TSubCategory[]",
          "references": {
            "TSubCategory": {
              "location": "import",
              "path": "../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "pageParam": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TListingType",
          "resolved": "string",
          "references": {
            "TListingType": {
              "location": "import",
              "path": "../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "page-param",
        "reflect": false
      },
      "isBrowser": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-browser",
        "reflect": false,
        "defaultValue": "isBrowser()"
      },
      "showCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-compare",
        "reflect": false,
        "defaultValue": "true"
      },
      "searchParams": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TSearchParams",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "TSearchParams": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "{}"
      },
      "isSubcategoryPage": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-subcategory-page",
        "reflect": false,
        "defaultValue": "false"
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      },
      "currentPageStorageKey": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "SUBCATEGORY/4200"
            }],
          "text": "key for getting breadcrumbs from the indexDB"
        },
        "attribute": "current-page-storage-key",
        "reflect": false
      },
      "productCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Setup productCtas logic.\nbuttons - predefined CTA buttons.\nproductProp - predefined property of product to find in list."
        },
        "defaultValue": "DEFAULT_CATEGORY_PRODUCT_CTAS"
      },
      "analyticsPageData": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "MetaTags['analyticsPageData']",
          "resolved": "{ articleTitle: string | number; businessUnit: string; pageRangeId: string; pageSubCategoryId: string; pageCategoryId: string; pageSubCategory: string; pageProductId: string; fromWebView: boolean; digitalPlatform: string; digitalPlatformCountry: string; pageLanguage: string; environment: string; template: string; pageSubSubCategory: string; pageTopCategory: string; pageCategory: string; pageTitle: string; }",
          "references": {
            "MetaTags": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "filtersNormalized": {},
      "filtrationSmartData": {},
      "pills": {},
      "isMobileView": {},
      "isFilterInMobileViewVisible": {},
      "isMobileCategorySelected": {},
      "filtersCategories": {},
      "productsCount": {},
      "selectedSectionsCount": {},
      "isProductsLoading": {},
      "sprykerParsedProducts": {},
      "selectedPage": {},
      "initialNavState": {},
      "currentNavState": {},
      "initialFilterUrl": {},
      "subCategoryProductListingParams": {},
      "selectedFilterUrl": {},
      "isLoadingFilters": {},
      "PBSoffset": {},
      "breadcrumbs": {}
    };
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "resize",
        "method": "windowSizeDidChange",
        "target": "window",
        "capture": false,
        "passive": true
      }, {
        "name": "pageSelected",
        "method": "choosePage",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "toggleMobileView",
        "method": "onToggleFilterMobileViewVisibility",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "selectCategory",
        "method": "onSelectCategoryHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "headerCategoryClick",
        "method": "mobileCategoryReset",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "filterStateChanged",
        "method": "onFilterStateChanged",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "removePill",
        "method": "removePillHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "resetAllClicked",
        "method": "resetAllFiltersHandler",
        "target": undefined,
        "capture": false,
        "passive": false
      }, {
        "name": "popstate",
        "method": "handlePopState",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "track_analytics",
        "method": "trackAnalyticsEventListener",
        "target": undefined,
        "capture": false,
        "passive": false
      }];
  }
}
